import { ComponentProps } from 'react'

import styles from './styles.module.scss'
import { Text, Icon } from '../..'

interface MessageProps extends ComponentProps<'span'> {
  appearance?: 'error' | 'neutral'
}

const Message = ({
  className,
  appearance,
  children,
  color,
  ...props
}: MessageProps) => (
  <Text
    size="sm"
    weight="medium"
    color={
      color || appearance === 'error' ? 'accent-red-default' : 'element-medium'
    }
    className={[styles.message, className].join(' ')}
    {...props}
  >
    {appearance === 'error' && (
      <Icon name="close-bold" width={8} color="accent-red-default" />
    )}
    {children}
  </Text>
)

export default Message
